/**
 * 消息类型
 *
 * @param msgType
 * @returns {string[]}
 */
function resolveMsgType (msgType) {
  switch (msgType) {
    // 学生提交异动申请
    case 'SUSPEND_APPLY_COMMITTED':
    case 'DROPOUT_APPLY_COMMITTED':
    case 'ROLL_CLASS_APPLY_COMMITTED':
      return ['PeStudentChangeAudit']
    // 教师提交成绩
    case 'ELECTIVE_SCORE_COMMITTED':
      return ['PeTchScoreConfirm', 'PeTchScoreNotConfirm']
    default:
      break
  }
}

export default {
  inject: ['$messageCenter'],
  methods: {
    onMessageClick (message) {
      const getMenus = resolveMsgType(message.type)
      if (getMenus && getMenus.length) {
        this.$messageCenter.navigateToPath(getMenus, () => {
          this.$messageCenter.hideLayout()
        })
      }
    }
  }
}
